import React, {useState} from "react";
import LoginContainer from "../../containers/LoginContainer";
import DHCarousel from "./DHCarousel";
import {useMediaQuery} from "@mui/material";

export default function HeaderBig() {

    const isMobile = useMediaQuery('(max-width:900px)');

    const [index, setIndex] = useState(0);

    if( isMobile ) {
        return <div style={{
            padding: "20px",
            backgroundColor: "#f2f2f2",
            color: "black",
            borderBottom: "1px solid #888888",
            width: "100%",
        }}>
            <div>
                <img alt="Logo" src={"/images/darthelfer_quer_schwarz.png"} style={{height:50}}/>
            </div>
            <div style={{marginTop:10}}>
                <div style={{fontSize:14, fontWeight:"bold", marginBottom:5}}>Deine persönliche Dartplattform!</div>
                <DHCarousel interval={5000} index={index} onIndexChange={(value) => setIndex(value)} model={[
                    {index: 0, value: <>... <strong>never</strong> stop the training</>},
                    {index: 1, value: <>... deinen <strong>Average</strong> immer im <strong>Blick</strong></>},
                    {index: 2, value: <>... <strong>Trainingseinheiten</strong> verwalten</>},
                    {index: 3, value: <>... dein <strong>Team</strong> beobachten</>},
                    {index: 4, value: <>... veranstalte <strong>deine</strong> Turniere</>},
                    {index: 5, value: <>... Ligaverwaltung</>},
                    {index: 6, value: <>... <strong>Statistiken</strong> ohne Ende</>},
                ]}/>
            </div>
            <div>
                <LoginContainer/>
            </div>
        </div>
    } else {
        return <div className="grid p-dir-row" style={{
            paddingTop: "20px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginRight: 0,
            marginLeft: 0,
            backgroundColor: "#f2f2f2",
            color: "black",
            borderBottom: "1px solid #888888",
            width: "100%",
        }}>
            <div className="col-12 sm:col-2 md:col-3 lg:col-1" style={{textAlign: "center"}}>
                <img alt="Logo" src={"/images/darthelfer.svg"} style={{width: "100%", maxWidth: "100px"}}/>
            </div>
            <div className="col-12 sm:col-10 md-9 lg:col-8 maintitle">
                <h1>Deine persönliche Dartplattform!</h1>
                <DHCarousel interval={5000} index={index} onIndexChange={(value) => setIndex(value)} model={[
                    {index: 0, value: <>... <strong>never</strong> stop the training</>},
                    {index: 1, value: <>... deinen <strong>Average</strong> immer im <strong>Blick</strong></>},
                    {index: 2, value: <>... <strong>Trainingseinheiten</strong> verwalten</>},
                    {index: 3, value: <>... dein <strong>Team</strong> beobachten</>},
                    {index: 4, value: <>... veranstalte <strong>deine</strong> Turniere</>},
                    {index: 5, value: <>... Ligaverwaltung</>},
                    {index: 6, value: <>... <strong>Statistiken</strong> ohne Ende</>},
                ]}/>
            </div>
            <div className="col-fixed" style={{width: 310, minWidth: 310}}>
                <LoginContainer/>
            </div>
        </div>
    }

}
